import React from 'react';
import { Box, Icon, InlineMessage, Typography } from '@saviynt/design-system';

import { msgs } from '../../utilities/messages';

import './MoreRecordsMessage.css';

// eslint-disable-next-line react/prop-types
function MoreRecordsMessage({ localize, isJitForApps }) {
  // localize param is instance of the useLocalize hook.
  const moreRecordsMessage = isJitForApps
    ? localize(msgs.pam.moreRecords.moreRecordsMessageTitleJfa)
    : localize(msgs.pam.moreRecords.moreRecordsMessageTitle);

  const moreRecordsDescription = isJitForApps
    ? localize(msgs.pam.moreRecords.moreRecordsMessageDescriptionJfa)
    : localize(msgs.pam.moreRecords.moreRecordsMessageDescription);

  return (
    <Box className='MoreRecordsMessage'>
      <InlineMessage
        leftIcon={<Icon kind='alertCriticalOutline' />}
        className='MoreRecordsMessage'>
        <div className='MoreRecordsMessage-text'>
          <Typography kind='h4'>{moreRecordsMessage}</Typography>
          <Typography kind='body2'>{moreRecordsDescription}</Typography>
        </div>
      </InlineMessage>
    </Box>
  );
}

export default MoreRecordsMessage;
